import React from "react";
import { Card, Row, Col, Table, Badge, ProgressBar } from "react-bootstrap";
import { useAnalytics } from "../hooks/useAnalytics";
import { RedactionDetail } from "../types/shared.types";

const EntityAnalysisPage: React.FC = () => {
  const { analyticsData, isLoading, error } = useAnalytics(0);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!analyticsData || !analyticsData.entity_frequency) {
    return <div>No entity data available.</div>;
  }

  return (
    <>
      <h2 className="my-4">Entity Frequency Analysis</h2>
      <Row>
        <Col>
          <Card>
            <Card.Header>Most Frequently Redacted Entities</Card.Header>
            <Card.Body>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Entity Name</th>
                    <th>Total Count</th>
                    <th>Entity Type</th>
                    <th>Avg. Confidence</th>
                  </tr>
                </thead>
                <tbody>
                  {analyticsData.entity_frequency
                    .sort(
                      (a: RedactionDetail, b: RedactionDetail) =>
                        b.count - a.count
                    )
                    .slice(0, 100) // Show top 100
                    .map((entity: RedactionDetail, index: number) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{entity.name}</td>
                        <td>
                          <Badge bg="warning" pill>
                            {entity.count}
                          </Badge>
                        </td>
                        <td>
                          <Badge
                            bg={
                              entity.entity_type === "PER"
                                ? "success"
                                : "primary"
                            }
                          >
                            {entity.entity_type}
                          </Badge>
                        </td>
                        <td>
                          <ProgressBar
                            now={entity.average_confidence * 100}
                            label={`${(entity.average_confidence * 100).toFixed(
                              1
                            )}%`}
                            variant={
                              entity.average_confidence > 0.9
                                ? "success"
                                : entity.average_confidence > 0.75
                                ? "warning"
                                : "danger"
                            }
                            style={{ height: "24px" }}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default EntityAnalysisPage;
